import { render, staticRenderFns } from "./SoldItemCardContent.vue?vue&type=template&id=48aaec19&scoped=true&"
import script from "./SoldItemCardContent.vue?vue&type=script&lang=ts&"
export * from "./SoldItemCardContent.vue?vue&type=script&lang=ts&"
import style0 from "./SoldItemCardContent.vue?vue&type=style&index=0&id=48aaec19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aaec19",
  null
  
)

export default component.exports